/* globals Landbot */

import React, { FC, useEffect, useState } from "react";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  closeButton: {
    position: "fixed",
    zIndex: 99999,
    top: theme.spacing(3),
    right: theme.spacing(3),
    height: 40,
    width: 40,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: "url('/images/Close.svg')",
  },
}));

export const LandbotContext = React.createContext({ launchBot: (timeout?: number) => {} });

const Landbot: FC<{ landbotUrl: string; onLaunchBot?: () => void }> = ({ landbotUrl, onLaunchBot, children }) => {
  const classes = useStyles();
  const [landbot, setLandbot] = useState<any>();
  const [landbotCloseButton, setLandbotCloseButton] = useState<any>();

  const launchBot = (timeout?: number) => {
    setTimeout(() => {
      if (window && window.Landbot) {
        try {
          const bot = new window.Landbot.Fullpage({
            configUrl: landbotUrl,
          });
          bot.onLoad(function() {
            setLandbot(bot);
            onLaunchBot && onLaunchBot();
          });
        } catch (e) {
          launchBot(1000);
        }
      } else {
        launchBot(300);
      }
    }, timeout || 10);
  };

  useEffect(() => {
    if (landbot && !landbotCloseButton) {
      const newElement = document.createElement("div");
      newElement.id = "landbotCloseButton";
      newElement.className = classes.closeButton;
      newElement.onclick = () => {
        if (landbotCloseButton) {
          landbotCloseButton.remove();
        }
        setLandbotCloseButton(null);
        if (landbot) {
          landbot.destroy();
        }
        setLandbot(null);
        (document.getElementsByTagName("BODY")[0] as any).style.overflow = "auto";
      };
      const elements = document.getElementsByClassName("LandbotFullpage");
      if (elements && elements.length > 0) {
        const element = elements[0];
        element.appendChild(newElement);
        setLandbotCloseButton(newElement);
      }
    }

    if (landbotCloseButton) {
      (document.getElementsByTagName("BODY")[0] as any).style.overflow = "hidden";
    } else {
      (document.getElementsByTagName("BODY")[0] as any).style.overflow = "auto";
    }

    return function cleanup() {
      (document.getElementsByTagName("BODY")[0] as any).style.overflow = "auto";
      if (landbotCloseButton) {
        landbotCloseButton.remove();
        setLandbotCloseButton(null);
      }
    };
  }, [landbot, landbotCloseButton, setLandbotCloseButton, classes]);

  return <LandbotContext.Provider value={{ launchBot }}>{children}</LandbotContext.Provider>;
};

export default Landbot;
